import React from 'react';
import { MiniCta } from '../CtaBlock';
import { manuals } from '../../data/content';
export function Manuals() {
  return <section className="bg-ink-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-190" data-mp="sx4x254slqb6">
      <div className="mx-auto max-w-5xl" data-id="element-191" data-mp="o4ljh863uv6d">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.22em] text-arc-light" data-id="element-192" data-mp="o3k975wwycpp">
          📦 Tutto ciò di cui hai bisogno
        </p>
        <h2 className="mt-3 text-center font-display text-4xl font-bold uppercase leading-none text-bone sm:text-6xl" data-id="element-193" data-mp="e7gxb8c9ezpk">
          I 6 Manuali Maestri
        </h2>

        <ol className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-194" data-mp="9a79fx4iqw3u">
          {manuals.map(manual => <li key={manual.number} className="flex h-full flex-col rounded-2xl border border-ink-500 bg-ink-700 p-5 sm:p-6" data-id="element-195" data-mp="583w12yahhfx">
              <div className="flex items-baseline gap-3" data-id="element-196" data-mp="1zjs1meims7nn">
                <span className="font-display text-4xl font-bold leading-none text-arc" data-id="element-197" data-mp="1ukntlr7g0fyw">
                  {manual.number}
                </span>
                <h3 className="font-display text-xl font-bold uppercase leading-tight text-bone sm:text-2xl" data-id="element-198" data-mp="1ciywkz4osdkl">
                  {manual.title}
                </h3>
              </div>
              <p className="mt-3 text-[15px] leading-relaxed text-mute" data-id="element-199" data-mp="13l5bkkcdh6cq">{manual.text}</p>
            </li>)}
        </ol>

        <MiniCta label="Voglio i 6 manuali maestri" data-id="element-200" data-mp="18l151png1fe1" />
      </div>
    </section>;
}